import React from 'react'
import enabledSettingIcon from '../images/appLogo.svg'

class LogoComponent extends React.Component {
  render () {
    return (
      <div style={styles.logoContent}>
        <img src={enabledSettingIcon} alt='true' style={styles.icon} />
      </div>
    )
  }
}

const styles = {
  logoContent: {
    height: '103px',
    marginTop: '5px'
  },
  icon: {
    marginTop: '5px',
    width: '32px',
    height: '36px'
  }
}

export default LogoComponent
